export default __webpack_public_path__ + "static/media/lomepal_club_lowdef.95893f98.png";